export const props = ['modelValue', 'placeholder', 'data', 'disabled', 'fullWidth', 'showReset', 'id', 'selected']

export const createUpdater = (value, emit) => ({
	update() {
		emit('input', value)
	}
})